import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { vendorInvoiceAPI } from "../../../../helpers/api/vendorInvoice";
import useReportFormat from "../useReportFormat";

const VendorList = ({ phaseId, blockId }) => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const formatCurrency = useReportFormat();

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (phaseId) params.phase = phaseId;
    if (blockId) params.block = blockId;
    vendorInvoiceAPI
      .getAllVendors(params)
      .then((res) => setVendors(Array.isArray(res) ? res : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [phaseId, blockId]);

  return (
    <div
      style={{
        background: "white",
        borderRadius: 16,
        border: "1px solid #f0f4ff",
        boxShadow: "0 4px 20px -4px rgba(0,0,0,0.05)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <div style={{ padding: "20px 24px 16px", borderBottom: "1px solid #f1f5f9" }}>
        <p style={{ fontWeight: 700, fontSize: "0.95rem", color: "#002045", margin: 0 }}>
          Vendors
        </p>
        <p style={{ fontSize: "0.72rem", color: "#94a3b8", fontWeight: 500, margin: "2px 0 0" }}>
          {loading ? "Loading…" : `${vendors.length} vendor${vendors.length !== 1 ? "s" : ""}`}
        </p>
      </div>

      {/* List */}
      <div style={{ overflowY: "auto", maxHeight: 350 }}>
        {loading ? (
          Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              style={{
                padding: "14px 24px",
                borderBottom: "1px solid #f8fafc",
                display: "flex",
                flexDirection: "column",
                gap: 6,
              }}
            >
              <div style={{ height: 12, width: "60%", background: "#f1f5f9", borderRadius: 4 }} />
              <div style={{ height: 10, width: "40%", background: "#f8fafc", borderRadius: 4 }} />
            </div>
          ))
        ) : vendors.length === 0 ? (
          <div
            style={{
              padding: 32,
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "0.82rem",
              fontWeight: 600,
            }}
          >
            No vendors found
          </div>
        ) : (
          vendors.map((v) => (
            <button
              key={v.cif}
              type="button"
              onClick={() => navigate(`/financial/invoices/vendors/${encodeURIComponent(v.cif)}`)}
              style={{
                width: "100%",
                padding: "14px 24px",
                borderBottom: "1px solid #f8fafc",
                border: "none",
                background: "none",
                textAlign: "left",
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 8,
                transition: "background 0.1s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#f8fafc")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
            >
              <div style={{ minWidth: 0 }}>
                <p
                  style={{
                    fontWeight: 600,
                    fontSize: "0.82rem",
                    color: "#002045",
                    margin: 0,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {v.name}
                </p>
                <p style={{ fontSize: "0.7rem", color: "#94a3b8", fontWeight: 500, margin: "2px 0 0" }}>
                  {v.cif}
                </p>
              </div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", flexShrink: 0 }}>
                <span
                  style={{
                    background: "#f0f4ff",
                    color: "#3b5bdb",
                    borderRadius: 99,
                    padding: "2px 8px",
                    fontSize: "0.68rem",
                    fontWeight: 700,
                  }}
                >
                  {v.invoice_count} inv
                </span>
                {v.total_amount != null && (
                  <span style={{ fontSize: "0.7rem", color: "#64748b", fontWeight: 600, marginTop: 3 }}>
                    {formatCurrency(v.total_amount)}
                  </span>
                )}
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default VendorList;
